// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner__RuAn_OsyMz{margin:0 auto}.tableFoot__ooogTYMg_9 td:first-child{display:none}`, "",{"version":3,"sources":["webpack://./src/assets/components/settings/components/sections/openingHours/openingHours.view.module.scss"],"names":[],"mappings":"AAAA,qBACE,aAAA,CAIA,sCACE,YAAA","sourcesContent":[".spinner {\n  margin: 0 auto;\n}\n\n.tableFoot {\n  td:first-child {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `spinner__RuAn_OsyMz`,
	"tableFoot": `tableFoot__ooogTYMg_9`
};
export default ___CSS_LOADER_EXPORT___;
